/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  assertIsInstructionWithAccounts,
  containsBytes,
  fixEncoderSize,
  getBytesEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
  SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
  SolanaError,
  type Address,
  type ClientWithPayer,
  type ClientWithRpc,
  type ClientWithTransactionPlanning,
  type ClientWithTransactionSending,
  type GetAccountInfoApi,
  type GetMultipleAccountsApi,
  type Instruction,
  type InstructionWithData,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  addSelfFetchFunctions,
  addSelfPlanAndSendFunctions,
  type SelfFetchFunctions,
  type SelfPlanAndSendFunctions,
} from '@solana/program-client-core';
import {
  getAmmConfigCodec,
  getInitConfigCodec,
  getLaunchCodec,
  getLaunchFeeStateCodec,
  getPoolCodec,
  getPositionCodec,
  getRehypeStateCodec,
  type AmmConfig,
  type AmmConfigArgs,
  type InitConfig,
  type InitConfigArgs,
  type Launch,
  type LaunchArgs,
  type LaunchFeeState,
  type LaunchFeeStateArgs,
  type Pool,
  type PoolArgs,
  type Position,
  type PositionArgs,
  type RehypeState,
  type RehypeStateArgs,
} from '../accounts';
import {
  getClaimFeesInstructionAsync,
  getInitializeRehypeInstructionAsync,
  getReplaceBeneficiaryInstructionAsync,
  getSettleFeesInstructionAsync,
  getSettleMigratedFeesInstructionAsync,
  parseClaimFeesInstruction,
  parseInitializeRehypeInstruction,
  parseReplaceBeneficiaryInstruction,
  parseSettleFeesInstruction,
  parseSettleMigratedFeesInstruction,
  type ClaimFeesAsyncInput,
  type InitializeRehypeAsyncInput,
  type ParsedClaimFeesInstruction,
  type ParsedInitializeRehypeInstruction,
  type ParsedReplaceBeneficiaryInstruction,
  type ParsedSettleFeesInstruction,
  type ParsedSettleMigratedFeesInstruction,
  type ReplaceBeneficiaryAsyncInput,
  type SettleFeesAsyncInput,
  type SettleMigratedFeesAsyncInput,
} from '../instructions';

export const DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS =
  'BpHX6orJ73qCvsfKkSMARQtqJvSPfqXNUfoes5rMND1D' as Address<'BpHX6orJ73qCvsfKkSMARQtqJvSPfqXNUfoes5rMND1D'>;

export enum DopplerRehypeRouterV1Account {
  AmmConfig,
  InitConfig,
  Launch,
  LaunchFeeState,
  Pool,
  Position,
  RehypeState,
}

export function identifyDopplerRehypeRouterV1Account(
  account: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): DopplerRehypeRouterV1Account {
  const data = 'data' in account ? account.data : account;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([218, 244, 33, 104, 203, 203, 43, 111]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Account.AmmConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([97, 166, 35, 7, 20, 2, 164, 126]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Account.InitConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([144, 51, 51, 163, 206, 85, 213, 38]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Account.Launch;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([1, 106, 55, 241, 179, 18, 230, 232]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Account.LaunchFeeState;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([241, 154, 109, 4, 17, 177, 109, 188]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Account.Pool;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([170, 188, 143, 228, 122, 64, 247, 208]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Account.Position;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([189, 101, 117, 1, 189, 167, 250, 225]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Account.RehypeState;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
    { accountData: data, programName: 'dopplerRehypeRouterV1' },
  );
}

export enum DopplerRehypeRouterV1Instruction {
  ClaimFees,
  InitializeRehype,
  ReplaceBeneficiary,
  SettleFees,
  SettleMigratedFees,
}

export function identifyDopplerRehypeRouterV1Instruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): DopplerRehypeRouterV1Instruction {
  const data = 'data' in instruction ? instruction.data : instruction;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([82, 251, 233, 156, 12, 52, 184, 202]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Instruction.ClaimFees;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([52, 224, 165, 199, 71, 188, 192, 155]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Instruction.InitializeRehype;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([255, 125, 195, 81, 143, 176, 242, 22]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Instruction.ReplaceBeneficiary;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([60, 221, 130, 229, 183, 234, 6, 159]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Instruction.SettleFees;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([73, 177, 82, 102, 67, 4, 231, 200]),
      ),
      0,
    )
  ) {
    return DopplerRehypeRouterV1Instruction.SettleMigratedFees;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
    { instructionData: data, programName: 'dopplerRehypeRouterV1' },
  );
}

export type ParsedDopplerRehypeRouterV1Instruction<
  TProgram extends string = 'BpHX6orJ73qCvsfKkSMARQtqJvSPfqXNUfoes5rMND1D',
> =
  | ({
      instructionType: DopplerRehypeRouterV1Instruction.ClaimFees;
    } & ParsedClaimFeesInstruction<TProgram>)
  | ({
      instructionType: DopplerRehypeRouterV1Instruction.InitializeRehype;
    } & ParsedInitializeRehypeInstruction<TProgram>)
  | ({
      instructionType: DopplerRehypeRouterV1Instruction.ReplaceBeneficiary;
    } & ParsedReplaceBeneficiaryInstruction<TProgram>)
  | ({
      instructionType: DopplerRehypeRouterV1Instruction.SettleFees;
    } & ParsedSettleFeesInstruction<TProgram>)
  | ({
      instructionType: DopplerRehypeRouterV1Instruction.SettleMigratedFees;
    } & ParsedSettleMigratedFeesInstruction<TProgram>);

export function parseDopplerRehypeRouterV1Instruction<TProgram extends string>(
  instruction: Instruction<TProgram> & InstructionWithData<ReadonlyUint8Array>,
): ParsedDopplerRehypeRouterV1Instruction<TProgram> {
  const instructionType = identifyDopplerRehypeRouterV1Instruction(instruction);
  switch (instructionType) {
    case DopplerRehypeRouterV1Instruction.ClaimFees: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerRehypeRouterV1Instruction.ClaimFees,
        ...parseClaimFeesInstruction(instruction),
      };
    }
    case DopplerRehypeRouterV1Instruction.InitializeRehype: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerRehypeRouterV1Instruction.InitializeRehype,
        ...parseInitializeRehypeInstruction(instruction),
      };
    }
    case DopplerRehypeRouterV1Instruction.ReplaceBeneficiary: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerRehypeRouterV1Instruction.ReplaceBeneficiary,
        ...parseReplaceBeneficiaryInstruction(instruction),
      };
    }
    case DopplerRehypeRouterV1Instruction.SettleFees: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerRehypeRouterV1Instruction.SettleFees,
        ...parseSettleFeesInstruction(instruction),
      };
    }
    case DopplerRehypeRouterV1Instruction.SettleMigratedFees: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: DopplerRehypeRouterV1Instruction.SettleMigratedFees,
        ...parseSettleMigratedFeesInstruction(instruction),
      };
    }
    default:
      throw new SolanaError(
        SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
        {
          instructionType: instructionType as string,
          programName: 'dopplerRehypeRouterV1',
        },
      );
  }
}

export type DopplerRehypeRouterV1Plugin = {
  accounts: DopplerRehypeRouterV1PluginAccounts;
  instructions: DopplerRehypeRouterV1PluginInstructions;
};

export type DopplerRehypeRouterV1PluginAccounts = {
  ammConfig: ReturnType<typeof getAmmConfigCodec> &
    SelfFetchFunctions<AmmConfigArgs, AmmConfig>;
  initConfig: ReturnType<typeof getInitConfigCodec> &
    SelfFetchFunctions<InitConfigArgs, InitConfig>;
  launch: ReturnType<typeof getLaunchCodec> &
    SelfFetchFunctions<LaunchArgs, Launch>;
  launchFeeState: ReturnType<typeof getLaunchFeeStateCodec> &
    SelfFetchFunctions<LaunchFeeStateArgs, LaunchFeeState>;
  pool: ReturnType<typeof getPoolCodec> & SelfFetchFunctions<PoolArgs, Pool>;
  position: ReturnType<typeof getPositionCodec> &
    SelfFetchFunctions<PositionArgs, Position>;
  rehypeState: ReturnType<typeof getRehypeStateCodec> &
    SelfFetchFunctions<RehypeStateArgs, RehypeState>;
};

export type DopplerRehypeRouterV1PluginInstructions = {
  claimFees: (
    input: MakeOptional<ClaimFeesAsyncInput, 'payer'>,
  ) => ReturnType<typeof getClaimFeesInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeRehype: (
    input: MakeOptional<InitializeRehypeAsyncInput, 'payer'>,
  ) => ReturnType<typeof getInitializeRehypeInstructionAsync> &
    SelfPlanAndSendFunctions;
  replaceBeneficiary: (
    input: ReplaceBeneficiaryAsyncInput,
  ) => ReturnType<typeof getReplaceBeneficiaryInstructionAsync> &
    SelfPlanAndSendFunctions;
  settleFees: (
    input: SettleFeesAsyncInput,
  ) => ReturnType<typeof getSettleFeesInstructionAsync> &
    SelfPlanAndSendFunctions;
  settleMigratedFees: (
    input: SettleMigratedFeesAsyncInput,
  ) => ReturnType<typeof getSettleMigratedFeesInstructionAsync> &
    SelfPlanAndSendFunctions;
};

export type DopplerRehypeRouterV1PluginRequirements = ClientWithRpc<
  GetAccountInfoApi & GetMultipleAccountsApi
> &
  ClientWithPayer &
  ClientWithTransactionPlanning &
  ClientWithTransactionSending;

export function dopplerRehypeRouterV1Program() {
  return <T extends DopplerRehypeRouterV1PluginRequirements>(client: T) => {
    return {
      ...client,
      dopplerRehypeRouterV1: <DopplerRehypeRouterV1Plugin>{
        accounts: {
          ammConfig: addSelfFetchFunctions(client, getAmmConfigCodec()),
          initConfig: addSelfFetchFunctions(client, getInitConfigCodec()),
          launch: addSelfFetchFunctions(client, getLaunchCodec()),
          launchFeeState: addSelfFetchFunctions(
            client,
            getLaunchFeeStateCodec(),
          ),
          pool: addSelfFetchFunctions(client, getPoolCodec()),
          position: addSelfFetchFunctions(client, getPositionCodec()),
          rehypeState: addSelfFetchFunctions(client, getRehypeStateCodec()),
        },
        instructions: {
          claimFees: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getClaimFeesInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          initializeRehype: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeRehypeInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          replaceBeneficiary: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getReplaceBeneficiaryInstructionAsync(input),
            ),
          settleFees: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSettleFeesInstructionAsync(input),
            ),
          settleMigratedFees: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSettleMigratedFeesInstructionAsync(input),
            ),
        },
      },
    };
  };
}

type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
